import React from 'react';
import "./Aboutus.css";
import about from "../images/about.png";


const Aboutus = () => {
    return (




        <div className="main">
            <h1>About Us</h1>
            <h2>Inside About Us</h2>
            <div className="s2">
                <h2>Inside About Us</h2>
                <div className="s5">
                    <div className="s7">
                        <img src={about} alt='abt' />
                    </div>
                    <div className="s8">
                        <img src={about} alt='abt' />
                    </div>
                </div>

                <div className="s6">
                    <div className="s9">
                        <img src={about} alt='abt' />
                    </div>
                    <div className="s10">
                        <img src={about} alt='abt' />
                    </div>
                </div>

            </div>


            <div className="s3">
                <h1>Current Projects</h1>
                <p>What We Do <br></br>Farmers First <br></br>Our Model <br></br>How We Grow <br></br>
                    Insights and <br></br>Data Library<br></br></p>
            </div>
            <div className="s4">


            <div className="s11">
                <p>What We Do <br></br>Farmers First <br></br>Our Model <br></br>How We Grow <br></br>
                    Insights and <br></br>Data Library<br></br></p>
            </div>
            <div className="s12">
                <p>What We Do <br></br>Farmers First <br></br>Our Model <br></br>How We Grow <br></br>
                    Insights and <br></br>Data Library<br></br></p>
            </div>
            <div className="s13">
                <p>What We Do <br></br>Farmers First <br></br>Our Model <br></br>How We Grow <br></br>
                    Insights and <br></br>Data Library<br></br></p>
            </div>
            </div>

        </div>


    );
};

export default Aboutus;